export const theme = Object.freeze({
  colors: {
    primary: {
      DEFAULT: "#00ADE6",
      50: "#F2FBFE",
      100: "#E6F7FD",
      200: "#BFEBF9",
      300: "#99DEF5",
      400: "#4DC6EE",
      500: "#00ADE6",
      600: "#009CCF",
      700: "#00688A",
      800: "#004E68",
      900: "#003445",
    },
  },
});
